/* 2026-10-25 (Claude). Joel: "Yes, move the remaining shared inline blocks into cached asset files the same way, and measure before and after".
   Moved out of snippets/site-menu-mobile.liquid so browsers cache it instead of downloading it inside every page. Same code as the inline copy it replaced.
   Edit THIS file now. Roll back: restore snippets/site-menu-mobile.liquid from OneDrive/Documents/AOAM-Theme-Backups/2026-10-25-inline-move/ and delete this file. */
  (function () {
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.gl-drawer [data-dropdown-toggle]')) return;
      requestAnimationFrame(function () {
        document.querySelectorAll('.gl-drawer .gl-dcat').forEach(function (row) {
          var btn = row.querySelector('[data-dropdown-toggle]');
          if (btn) btn.setAttribute('aria-expanded', row.classList.contains('active') ? 'true' : 'false');
        });
      });
    });
  })();

  
  (function () {
    var PAD = 10;

    function bring(row) {
      var sc = row.closest('.gl-dscroll');
      var card = row.querySelector('.gl-cat');
      if (!sc || !card) return;

      var view = sc.clientHeight;
      var max = sc.scrollHeight - view;
      if (view <= 0 || max <= 0) return;

      
      var box = sc.getBoundingClientRect();
      var top = sc.scrollTop + (card.getBoundingClientRect().top - box.top);
      var bottom = sc.scrollTop + (row.getBoundingClientRect().bottom - box.top);

      var want;
      if (bottom - top + PAD * 2 <= view) {
        want = Math.min(Math.max(sc.scrollTop, bottom + PAD - view), top - PAD);
      } else {
        want = top - PAD;
      }
      want = Math.max(0, Math.min(want, max));
      if (Math.abs(want - sc.scrollTop) < 2) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try {
        sc.scrollTo({ top: want, behavior: reduce ? 'auto' : 'smooth' });
      } catch (err) {
        sc.scrollTop = want;
      }
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('.gl-drawer [data-dropdown-toggle]');
      if (!btn) return;
      var row = btn.closest('.gl-dcat');
      if (!row) return;
      
      requestAnimationFrame(function () {
        if (row.classList.contains('active')) bring(row);
      });
    });
  })();

  
  (function () {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var icon = e.target.closest('.gl-drawer .site-header--brand a.cstm_icon');
      if (!icon) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var closer = document.querySelector('.gl-drawer .btn-close.js-close-mobile-nav');
      if (closer) closer.click();
      var trig = document.querySelector('[data-header-cart-trigger]');
      if (!trig) return;
      requestAnimationFrame(function () {
        setTimeout(function () { trig.click(); }, 60);
      });
    }, true);
  })();

  
  (function () {
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    function start() {
    var host = document.querySelector('.gl-drawer .gl-search-host');
    var panel = document.getElementById('search-results');
    if (!host || !panel) return;

    var home = panel.parentElement;
    var next = panel.nextElementSibling;

    function adopt() {
      if (panel.parentElement !== host) host.appendChild(panel);
    }
    function restore() {
      if (panel.parentElement === host) {
        if (next && next.parentElement === home) home.insertBefore(panel, next);
        else home.appendChild(panel);
      }
    }

    var input = document.querySelector('.gl-drawer .header-search__form input[type="search"]');
    if (input) {
      
      input.addEventListener('focus', adopt);
      input.addEventListener('keyup', adopt);
    }

    
    
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-gl-search-open]')) return;
      e.preventDefault();
      var opener = document.querySelector('.button-toggle.js-drawer-open-left');
      if (opener) opener.click();
      if (input) {
        adopt();
        input.focus({preventScroll: true});
      }
    });

    var drawer = document.querySelector('.block-mobile__drawer.gl-drawer');
    if (drawer && window.MutationObserver) {
      
      new MutationObserver(function () {
        if (panel.parentElement !== host) return;
        if (!drawer.closest('.is-active, .drawer--is-open, .js-drawer-open')) {
          if (drawer.getBoundingClientRect().width === 0) restore();
        }
      }).observe(document.documentElement, {attributes: true, subtree: true, attributeFilter: ['class']});
    }
    }
  })();

  
  (function () {
    var drawer = document.querySelector('.block-mobile__drawer.gl-drawer');
    if (!drawer) return;
    var sc = drawer.querySelector('.gl-dscroll');
    var rail = drawer.querySelector('.gl-srail');
    if (!sc || !rail) return;

    function sync() {
      var view = sc.clientHeight;
      var full = sc.scrollHeight;
      var max = full - view;
      if (max <= 4 || view <= 0) {
        drawer.classList.remove('gl-can-scroll', 'gl-has-more');
        return;
      }
      var thumb = Math.max(40, Math.round(view * view / full));
      var pos = Math.round((sc.scrollTop / max) * (view - thumb));
      rail.style.setProperty('--gl-srail-top', sc.offsetTop + 'px');
      rail.style.setProperty('--gl-srail-h', view + 'px');
      rail.style.setProperty('--gl-srail-th', thumb + 'px');
      rail.style.setProperty('--gl-srail-ty', pos + 'px');
      drawer.classList.add('gl-can-scroll');
      drawer.classList.toggle('gl-has-more', sc.scrollTop < max - 8);
    }

    function later() {
      requestAnimationFrame(sync);
      setTimeout(sync, 380);
    }

    sc.addEventListener('scroll', sync, {passive: true});
    window.addEventListener('resize', later);
    window.addEventListener('orientationchange', later);
    drawer.addEventListener('click', later);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.button-toggle.js-drawer-open-left, [data-gl-search-open]')) later();
    });
    if (window.ResizeObserver) new ResizeObserver(sync).observe(sc);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later);
    later();
  })();

  
  (function () {
    var drawer = document.querySelector('.block-mobile__drawer.gl-drawer');
    if (!drawer) return;
    var scope = drawer.closest('#header-mobile__menu') || drawer;
    var el = null;
    var timer = null;

    function overlay() {
      if (el && el.isConnected) return el;
      el = document.createElement('div');
      el.className = 'gl-navload';
      el.setAttribute('aria-hidden', 'true');
      var ring = document.createElement('span');
      ring.className = 'gl-navload__ring';
      el.appendChild(ring);
      document.body.appendChild(el);
      return el;
    }

    
    function show(ghost) {
      if (window.AOAM_LOAD) { window.AOAM_LOAD.show(ghost === true); return; }
      
      if (ghost === true) return;
      var o = overlay();
      o.getBoundingClientRect();   
      o.classList.add('is-on');
      clearTimeout(timer);
      
      timer = setTimeout(hide, 8000);
    }

    function hide(snap) {
      clearPress();
      if (window.AOAM_LOAD) window.AOAM_LOAD.hide(snap === true);
      clearTimeout(timer);
      if (el) el.classList.remove('is-on');
    }

    
    var armX = 0, armY = 0, armed = false, tapTimer = null, earlyShown = false;

    
    var PRESS_LEAD = 120;
    var ghostTimer = null;
    var pressEl = null;

    function setPress(a) {
      if (pressEl && pressEl !== a) pressEl.classList.remove('gl-press');
      pressEl = a || null;
      if (pressEl) pressEl.classList.add('gl-press');
    }

    function clearPress() {
      if (pressEl) pressEl.classList.remove('gl-press');
      pressEl = null;
      clearTimeout(ghostTimer);
    }

    function navigates(a) {
      if (!a || a.target === '_blank') return false;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return false;
      return !/^(javascript|mailto|tel|sms):/i.test(href);
    }

    scope.addEventListener('touchstart', function (e) {
      if (!e.target || !e.target.closest) return;
      
      if (e.target.closest('[data-dropdown-toggle], [data-disclosure-toggle]')) return;
      var pressA = e.target.closest('a[href]');
      if (!navigates(pressA)) return;
      var t = e.touches && e.touches[0];
      if (!t) return;
      armX = t.clientX; armY = t.clientY; armed = true; earlyShown = true;
      clearTimeout(tapTimer);
      
      setPress(pressA);
      
      clearTimeout(ghostTimer);
      ghostTimer = setTimeout(function () { if (armed || earlyShown) show(true); }, PRESS_LEAD);
    }, {passive: true});

    scope.addEventListener('touchmove', function (e) {
      if (!armed) return;
      var t = e.touches && e.touches[0];
      if (!t) return;
      if (Math.abs(t.clientX - armX) > 8 || Math.abs(t.clientY - armY) > 8) {
        armed = false; earlyShown = false; hide(true);
      }
    }, {passive: true});

    scope.addEventListener('touchcancel', function () {
      if (!armed) return;
      armed = false; earlyShown = false;
      hide(true);
    }, {passive: true});

    scope.addEventListener('touchend', function () {
      if (!armed) return;
      armed = false;
      clearTimeout(tapTimer);
      tapTimer = setTimeout(function () { earlyShown = false; hide(); }, 700);
    }, {passive: true});

    
    function scrimFor(e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return '';
      if (!e.target || !e.target.closest) return '';

      
      if (e.target.closest('[data-disclosure-option]')) return 'option';

      
      if (e.defaultPrevented) return '';

      
      return navigates(e.target.closest('a[href]')) ? 'link' : '';
    }

    scope.addEventListener('click', function (e) {
      clearTimeout(tapTimer);
      var kind = scrimFor(e);
      if (!kind) {
        if (earlyShown) hide(true);
        clearPress();
        earlyShown = false;
        return;
      }
      earlyShown = false;
      
      var clickA = e.target.closest('a[href]');
      if (clickA) setPress(clickA);
      show();
      if (kind !== 'link') return;
      
      setTimeout(function () { if (e.defaultPrevented) hide(); }, 0);
    });

    
    scope.addEventListener('submit', function () { show(); });

    
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.js-close-mobile-nav, .js-drawer-close')) hide();
    });
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) hide(); });
  })();
